var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCobroAnticipado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9953 19.1782C23.8312 22.3094 19.351 24.5 14 24.5C8.54801 24.5 4 22.226 4 19V9L4.00466 8.82177C4.16875 5.69056 8.64898 3.5 14 3.5C19.452 3.5 24 5.77401 24 9V19L23.9953 19.1782ZM22.0011 12.3655C20.1646 13.6958 17.2422 14.5 14 14.5C10.7584 14.5 7.83644 13.6961 5.99992 12.3662L6 14C6 15.7446 9.51086 17.5 14 17.5C18.4891 17.5 22 15.7446 22 14L22.0011 12.3655ZM14 5.5C9.51086 5.5 6 7.25543 6 9C6 10.7446 9.51086 12.5 14 12.5C18.4891 12.5 22 10.7446 22 9C22 7.25543 18.4891 5.5 14 5.5ZM22.0011 17.3655C20.1646 18.6958 17.2422 19.5 14 19.5C10.7584 19.5 7.83644 18.6961 5.99992 17.3662L6 19L6.00517 19.1163C6.15652 20.8217 9.61062 22.5 14 22.5C18.4891 22.5 22 20.7446 22 19L22.0011 17.3655Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCobroAnticipado);
export default __webpack_public_path__ + "static/media/cobro-anticipado.dbc986edd74d8e1470858f4b349925cf.svg";
export { ForwardRef as ReactComponent };